var _rect, _path, _g, _defs;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSmsIcon = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#0A9872"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1507_4241)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1507_4241",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 8H8V24H24V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1507_4241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3334 9.33334H12.6667C10.8267 9.33334 9.33337 10.82 9.33337 12.6533V16.64V17.3067C9.33337 19.14 10.8267 20.6267 12.6667 20.6267H13.6667C13.8467 20.6267 14.0867 20.7467 14.2 20.8933L15.2 22.22C15.64 22.8067 16.36 22.8067 16.8 22.22L17.8 20.8933C17.9267 20.7267 18.1267 20.6267 18.3334 20.6267H19.3334C21.1734 20.6267 22.6667 19.14 22.6667 17.3067V12.6533C22.6667 10.82 21.1734 9.33334 19.3334 9.33334ZM13.3334 16C12.96 16 12.6667 15.7 12.6667 15.3333C12.6667 14.9667 12.9667 14.6667 13.3334 14.6667C13.7 14.6667 14 14.9667 14 15.3333C14 15.7 13.7067 16 13.3334 16ZM16 16C15.6267 16 15.3334 15.7 15.3334 15.3333C15.3334 14.9667 15.6334 14.6667 16 14.6667C16.3667 14.6667 16.6667 14.9667 16.6667 15.3333C16.6667 15.7 16.3734 16 16 16ZM18.6667 16C18.2934 16 18 15.7 18 15.3333C18 14.9667 18.3 14.6667 18.6667 14.6667C19.0334 14.6667 19.3334 14.9667 19.3334 15.3333C19.3334 15.7 19.04 16 18.6667 16Z",
    fill: "#EFF2F6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1507_4241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSmsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sms-icon.c7aa3da0.svg";
export { ForwardRef as ReactComponent };